import React, { createContext, useContext } from "react";

import { softwareRecommendation } from "./software-page-product-recommendation";

export interface PersonalizationRecommendationContextValue {
    userSegments?: Record<string, unknown>;
    recommendedProduct?: softwareRecommendation[];
}

export const PersonalizationRecommendationContext = createContext<
    PersonalizationRecommendationContextValue | undefined
>(undefined);

export const PersonalizationRecommendationProvider: React.FC<{
    value: PersonalizationRecommendationContextValue;
    children: React.ReactNode;
}> = ({ value, children }) => {
    return (
        <PersonalizationRecommendationContext.Provider value={value}>
            {children}
        </PersonalizationRecommendationContext.Provider>
    );
};

export const usePersonalizationRecommendation =
    (): PersonalizationRecommendationContextValue => {
        const recommendationContext = useContext(
            PersonalizationRecommendationContext
        );
        if (recommendationContext === undefined) {
            throw new Error(
                "usePersonalizationRecommendation must be used within a PersonalizationRecommendationProvider"
            );
        }
        return recommendationContext;
    };
